import { FSCollections } from '@src/constants/database';
import { API_OPERATIONS } from '@src/util/cloud-functions/operations';

import IntlMessages from '@src/util/IntlMessages';

import { DASHBOARDS_FORMS } from '../../../constants';
import { getChartActionButtons } from '../actionButtons/chartActionButtons';
import { renderChartContent } from '../renderers/chartRenderer';
import { transformChartData } from '../transformers/chartTransformer';

import type { WidgetConfig } from './types';

export const chartConfig: WidgetConfig = {
  collectionName: FSCollections.CHARTS,
  componentType: DASHBOARDS_FORMS.STATISTIC_ONLY_NUMBER_COMPONENTS,
  op: API_OPERATIONS.NUMBER_METRICS_DASHBOARD,

  buildParams: (queryParams, commonParams) => ({
    ...commonParams,
    componentId: queryParams.componentId,
    triggerId: queryParams.triggerId,
    userIds: queryParams?.userIds || [],
    groupIds: queryParams?.groupIds || [],
    formId: queryParams?.formId || null,
    scheduleIds: queryParams?.scheduleIds || [],
    divisionIds: queryParams?.divisionIds || [],
    templateIds: queryParams?.templateIds || [],
    locationIds: queryParams?.locationIds || null,
    locationGroupId: queryParams.locationGroupId || null,
    type: queryParams?.type || null,
  }),

  transformData: transformChartData,
  renderContent: renderChartContent,

  getSubTitle: ({ data }) => {
    if (!data) return null;
    return (
      <IntlMessages
        id="dashboards.chart.totalEvents"
        values={{ total: data.info?.totalEvents || 0 }}
      />
    );
  },

  getActionButtons: getChartActionButtons,
};
